import { render, staticRenderFns } from "./BldPager.vue?vue&type=template&id=04a34edd&scoped=true&"
import script from "./BldPager.vue?vue&type=script&lang=js&"
export * from "./BldPager.vue?vue&type=script&lang=js&"
import style0 from "./BldPager.vue?vue&type=style&index=0&id=04a34edd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a34edd",
  null
  
)

export default component.exports